import { render, staticRenderFns } from "./SkupoviNavigation.vue?vue&type=template&id=6bb88da4&scoped=true&"
import script from "./SkupoviNavigation.vue?vue&type=script&lang=js&"
export * from "./SkupoviNavigation.vue?vue&type=script&lang=js&"
import style0 from "./SkupoviNavigation.vue?vue&type=style&index=0&id=6bb88da4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb88da4",
  null
  
)

export default component.exports